import React from 'react';
import { NavLink } from 'react-router-dom';
// components
import AuthForm from 'components/forms/AuthForm/AuthForm';
// scss
import './AuthPage.scss';

const AuthPage = ({ page }) => {
  const isLoginPage = page === 'login';
  const title = isLoginPage ? 'З поверненням!' : 'Вітаємо!';
  const msg = isLoginPage ? '' : 'Щоб продовжити, зареєструйтесь!';
  const navText = isLoginPage ? 'Не маєте акаунту?' : 'Вже маєте акаунту?';
  const navLinkText = isLoginPage ? 'Зареєструватись' : 'Увійти';
  const navLinkUrl = isLoginPage ? '/signup' : '/login';

  return (
    <main className="auth-page">
      <section className="auth">
        <div className="auth__container">
          <h1 className="auth__title">{title}</h1>
          <strong className="auth__msg">{msg}</strong>
          <AuthForm isLoginPage={isLoginPage} />
          <p className="auth__nav"> {navText} <NavLink className="auth__nav-link" to={navLinkUrl}>{navLinkText}</NavLink> </p>
        </div>
      </section>
    </main>
  );
};

export default AuthPage;
